import { toSchoolApiPayload } from '../../../utils/schoolFormMapper';

// Pure builder for the updateSchoolDetailOnly body. The mapped payload already carries the
// legacy Boarding/Post16/Nursery strings from the loaded values, so they are NOT re-read off
// the raw entity here — doing so blanked them, because getInfo returns camelCase. GroupType
// is the one carried-through field the form does not surface and the mapper does not emit, so
// it is read casing-tolerantly to preserve it. The id is read tolerantly too.
export const buildUpdateSchoolPayload = (values, school = {}) => ({
  Id: school.Id ?? school.id,
  ...toSchoolApiPayload(values),
  WondeeSchoolUrn: parseInt(values.Urn, 10) || 0,
  GroupType: school.GroupType ?? school.groupType ?? '',
});
